import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasPartner: boolean
}

/**
 * Two different empties. Without a partner the list is not merely empty — it cannot be
 * requested at all, because the endpoint's `partnerId` is `@IsNotEmpty`.
 */
const EmptyScheduledActionsComponent = ({ hasPartner }: Props) => {
  return (
    <div css={tw`flex flex-1 flex-col items-center justify-center gap-2 p-10`}>
      <Typography variant="body1" css={tw`text-shades-700`}>
        {hasPartner
          ? 'No scheduled actions for this partner'
          : 'Select a partner to see its scheduled actions'}
      </Typography>
    </div>
  )
}

export const EmptyScheduledActions = memo(EmptyScheduledActionsComponent)
